import { split } from '@spazious/dollhouse-selector';
import { createRemoveNodeAction } from '@spazious/dollhouse-shallow-graph';

import { Commander, CommanderActionTypesEnum } from '../types.js';

import { GraphNodeAction } from './GraphNodeAction.js';

export interface DeleteActionPayload {}

export class DeleteAction extends GraphNodeAction<
  CommanderActionTypesEnum.Delete,
  DeleteActionPayload
> {
  constructor(commander: Commander, selector: string, payload?: DeleteActionPayload) {
    super(commander, CommanderActionTypesEnum.Delete, selector, payload ?? {});
  }

  // eslint-disable-next-line no-unused-vars
  update(_payload: DeleteActionPayload): void {
    throw new Error('Method not supported.');
  }

  _apply(): void {
    const { staging, prevState } = this.commander;

    const selectors = split(this.selector());

    staging.abort();

    staging.add(
      selectors.map((selector) => {
        const node = prevState.nodes[selector];

        if (!node) {
          throw new Error(`Node with selector "${selector}" not found`);
        }

        return createRemoveNodeAction(selector);
      })
    );
  }
}
